import React, { useMemo, useState, useContext } from 'react'
import TableShipmentCharges from './tableShipmentCharges'
import CancelIcon from '@mui/icons-material/Cancel'
import LensOutlinedIcon from '@mui/icons-material/LensOutlined'
import '../../pages/GO/go.css'
import TableEquipments from '../../components/utils/tableEquipments'
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat'
import { Anchor, Star, Delete, RequestQuoteOutlined } from '@mui/icons-material'
import GroupIcon from '@mui/icons-material/Group'
import { useMediaQuery, Popover, TextField as MuiTextField, IconButton, MenuItem, ListItemText, Divider } from '@mui/material'
import { M_MessageBoard, M_TextArea, M_Select, M_CheckBox, M_InputTextField, M_DrawerTableTextField, M_TimeLine, M_Button, M_Fieldset, M_Header, M_FormFavorites, useFavorites, NavigateContext } from 'src/M_Components'
import M_RadioButton from 'src/M_Components/M_RadioButton/M_RadioButton'

function GroupFavoriteActions({ groupName, t }) {
    const favCtx = useFavorites();
    const [anchorEl, setAnchorEl] = useState(null);
    const [name, setName] = useState('');

    if (!favCtx) return null;

    const { saveGroupFavorite, getGroupFavorites, handleApplyFavorite, handleDeleteFavorite } = favCtx;
    const groupFavs = getGroupFavorites(groupName);

    return (
        <div style={{ position: 'absolute', top: '10px', right: '18px', zIndex: 10 }}>
            <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
                <Star sx={{ color: groupFavs.length > 0 ? 'var(--color-yellow, #f9a825)' : '#ccc', fontSize: '20px' }} />
            </IconButton>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={() => { setAnchorEl(null); setName(''); }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <div style={{ minWidth: '250px' }}>
                    <div style={{ padding: '12px', display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <M_InputTextField
                            size="small"
                            label={t('FavoriteName') || 'Name'}
                            value={name}
                            onChange={e => setName(e.target.value)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' && name.trim()) {
                                    saveGroupFavorite(groupName, name);
                                    setName('');
                                }
                            }}
                            autoFocus
                            fullWidth
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Save') || 'Save'}
                            backgroundColor={'var(--color-blue)'}
                            labelColor="var(--color-white)"
                            onClick={() => {
                                if (name.trim()) {
                                    saveGroupFavorite(groupName, name);
                                    setName('');
                                }
                            }}
                        />
                    </div>
                    {groupFavs.length > 0 && <Divider />}
                    {groupFavs.map(fav => (
                        <MenuItem
                            key={fav.Id}
                            onClick={() => { handleApplyFavorite(fav); setAnchorEl(null); }}
                            sx={{
                                '& .fav-delete': { opacity: 0, transition: 'opacity 0.2s' },
                                '&:hover .fav-delete': { opacity: 1 }
                            }}
                        >
                            <ListItemText>{fav.Description}</ListItemText>
                            <IconButton
                                className="fav-delete"
                                size="small"
                                onClick={(e) => { e.stopPropagation(); handleDeleteFavorite(fav.Id, e); }}
                                sx={{ marginLeft: '8px' }}
                            >
                                <Delete fontSize="small" sx={{ color: 'var(--color-red, #d32f2f)' }} />
                            </IconButton>
                        </MenuItem>
                    ))}
                </div>
            </Popover>
        </div>
    );
}

export default function SimpleApproveBooking({ valueTimeline, submitForApproval, t, submitedApproval, voyage, voyageDict, addValue, setVoyageDict, entities,
    isChecked, addRejectFields, entitiesDict, setEntitiesDict, portsLocations, locationsDict, shipmentObjArray, setShipmentObjArray, setLocationsDict, openConfirmModal,
    handleCloseConfirmModal, setRadioButton, radioButton, rejectFields, rejectFieldsNotes, finalNotes, setFinalNotes, setDefaultBooking, selectedLine, setSelectedLine,
    openDrawer, setOpenDrawer, reprovedRows, setReprovedRows, onReprove, extraValues, setExtraValues, submitedReproval, getAccountCompany, companies, confirmationModal,
    confirmApproval, closeModal, approveSuccess, isApprove, extraValuesArray, toastMessages, drawerName, setDrawerName, errorMessage, changedList, bookingLine, draft,
    shipmentArray, setShipmentArray, ctx, leavingPage, setLeavingPage, functionLeavingPage, fieldsInDrawerEquipment, fieldsInDrawerShipment, equipmentDict, setEquipmentDict, id,
    shipmentChargesArray = [], isAdmin = false, onRefreshCharges }) {

    const matches = useMediaQuery('(min-width:900px)')
    const ctx2 = useContext(NavigateContext)

    const availableShipments = useMemo(() => {
        const seen = new Set()
        return (shipmentObjArray || [])
            .filter(eq => eq.ShipmentId && !seen.has(eq.ShipmentId) && seen.add(eq.ShipmentId))
            .map(eq => ({ ShipmentId: eq.ShipmentId, TransportKey: eq.Shipment }))
    }, [shipmentObjArray])


    const handleOpenCreate = (shipmentId) => {
        ctx.passValue.set('operation', 'create')
        ctx.passValue.set('sourceTabUrl', 'approveBooking')
        ctx.passValue.set('Row', {
            BookingId: extraValues?.get('id'),
            BookingNumber: extraValues?.get('BookingNumber'),
            ShipmentId: shipmentId,
        })
        ctx2.newTab('go/shipmentChargesDetail', t('CreateShipmentCharge'))
    }

    const handleOpenEdit = (row) => {
        ctx.passValue.set('operation', 'edit')
        ctx.passValue.set('sourceTabUrl', 'approveBooking')
        ctx.passValue.set('Row', row)
        ctx2.newTab('go/shipmentChargesDetail', t('EditShipmentCharge'))
    }

    return (
        <div style={{}}>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        <M_Button
                            label={t("LabelRejectBooking")}
                            tooltip={t("LabelRejectBooking")}
                            icon={<img src='/icons/svgsDaNet/x-circle.svg' style={{ filter: 'invert(8%) sepia(94%) saturate(6897%) hue-rotate(3deg) brightness(108%) contrast(110%)', width: '20px' }} className='iconCreateBooking' alt='SaveAsDraft' />}
                            onClick={() => submitForApproval()}
                        />
                        <M_Button
                            label={t("LabelAcceptBooking")}
                            tooltip={t("LabelAcceptBooking")}
                            icon={<img src='/icons/svgsDaNet/check-circle.svg' style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '20px' }} className='iconCreateBooking' alt='Submit for approval' />}
                            onClick={() => submitedApproval()}
                        />
                    </>
                }
            />
            <div className='principalDivTimeline'>
                <div className='divTimeline'>
                    <M_TimeLine valueTimeline={valueTimeline} />
                </div>
            </div>
            <div className='divBaseBooking'>
                <div className='divButtonSubmitBooking'>
                    <div className='bookingNumber' style={{ marginLeft: '40px', display: 'flex', alignItems: 'center' }}>
                        <h4 style={{ margin: '0' }}>Booking Number: &nbsp; </h4><h2 style={{ margin: '0' }}>{extraValues.get('BookingNumber')}</h2>
                    </div>
                    {extraValues.get('QuoteName') && 
                        <div className='bookingNumber' style={{ marginLeft: '40px', display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                            <h4 style={{ margin: '0' }}>Quote Name: &nbsp; </h4><h2 style={{ margin: '0' }}> {extraValues.get('QuoteName')}</h2>
                        </div>
                    }
                </div>
                <div className='menusBooking'>
                    <M_FormFavorites
                        entityName="Bookings"
                        pageUrl="Booking"
                        varNameDict={voyageDict}
                        setVarNameDict={setVoyageDict}
                        onAfterApply={() => { }}
                    >
                        <M_Fieldset
                            labelInside
                            label={<span style={{ display: 'flex', alignItems: 'center' }}><DirectionsBoatIcon style={{ marginRight: '5px' }} /> {t("Voyage")}</span>}
                            elements={
                                <div className='divTextfieldVoyage'>
                                    {voyage.map((value, index) => (
                                        <div key={index}>
                                            {value.label === 'Voyage' ?
                                                <div key={index} className='textfield' >
                                                    <M_DrawerTableTextField
                                                        tableLabel={'Voyages'}
                                                        label={value.label}
                                                        value={
                                                            extraValues.get('transport id') ?
                                                                {
                                                                    Id: extraValues.get('transport id'),
                                                                    VesselCode: voyageDict.get('Vessel'),
                                                                    VoyageNumber: voyageDict.get('Voyage'),
                                                                } :
                                                                null
                                                        }
                                                        entity={'transport'}
                                                        filterField={"VoyageNumber"}
                                                        labelFields={['VesselCode', 'VoyageNumber']}
                                                        onSubmitValue={(obj) => {
                                                            if (obj) {
                                                                addValue('transport id', obj.Id, extraValues, setExtraValues)
                                                                addValue('Voyage', obj['VoyageNumber'], voyageDict, setVoyageDict)
                                                                addValue('Vessel', obj['VesselCode'], voyageDict, setVoyageDict)
                                                            } else {
                                                                addValue('transport id', '', extraValues, setExtraValues)
                                                                addValue('Voyage', '', voyageDict, setVoyageDict)
                                                                addValue('Vessel', '', voyageDict, setVoyageDict)
                                                            }
                                                        }}
                                                        color={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                        secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                        favoritesFieldName="Voyage"
                                                        favoritesGroupName="Voyage"
                                                        favoritesIdKey="transport id"
                                                        favoritesVarKey="Voyage"
                                                    />
                                                </div>
                                                :
                                                <div key={index} className='textfield' >
                                                    <M_InputTextField
                                                        label={value.label}
                                                        disabled
                                                        value={voyageDict.get(value.label) || ''}
                                                        color={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                        secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : null}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    ))}
                                    <div style={{ height: '62px' }}></div>
                                </div>
                            }
                        />
                    </M_FormFavorites>
                    <M_FormFavorites
                        entityName="Bookings"
                        pageUrl="Booking"
                        varNameDict={entitiesDict}
                        setVarNameDict={setEntitiesDict}
                        onAfterApply={() => { }}
                    >
                        <div style={{ position: 'relative' }}>
                            <GroupFavoriteActions groupName="Entities" t={t} />
                            <M_Fieldset
                                labelInside
                                label={<span style={{ display: 'flex', alignItems: 'center', }}><GroupIcon style={{ marginRight: '5px' }} /> {t("Entities")}</span>}
                                elements={
                                    <div className='divTextfieldEntities'>
                                        {companies.length > 1 &&
                                            <div className='textfield'>
                                                <M_Select
                                                    required
                                                    autocomplete
                                                    label={'Company'}
                                                    value={entitiesDict.get('Company') ?
                                                        {
                                                            label: entitiesDict.get('Company'),
                                                            value: entitiesDict.get('UserCompanyId')
                                                        } : null}
                                                    options={companies?.map((company) => {
                                                        return { label: company.Code, value: company.Id, accountId: company.AccountId }
                                                    })}
                                                    onChangeValue={(obj) => {
                                                        if (obj) {

                                                            addValue('Company', obj.label, entitiesDict, setEntitiesDict)
                                                            addValue('UserCompanyId', obj.value, extraValues, setExtraValues)
                                                            getAccountCompany(obj.accountId)
                                                        } else {
                                                            addValue('Company', '', entitiesDict, setEntitiesDict)
                                                            addValue('UserCompanyId', '', extraValues, setExtraValues)
                                                            getAccountCompany(null)
                                                        }
                                                    }}
                                                    size={'100%'}
                                                    favoritesFieldName="Company"
                                                    favoritesGroupName="Entities"
                                                    favoritesIdKey="UserCompanyId"
                                                    favoritesVarKey="Company"
                                                />
                                            </div>
                                        }
                                        {entities.map((key, index) => (
                                            <div className='textfield' key={index}>
                                                {key.label === 'Client' ?

                                                    companies.length == 0 ?
                                                        <></>
                                                        : companies.length == 1 ?
                                                            <>
                                                                <M_CheckBox
                                                                    icon={<LensOutlinedIcon />}
                                                                    checkedIcon={<CancelIcon />}
                                                                    checked={isChecked.includes(key.code)}
                                                                    onChange={(e) => addRejectFields(e, key.code, entitiesDict)}
                                                                />
                                                                <M_InputTextField
                                                                    label={key.label}
                                                                    value={entitiesDict.get(key.code) || ''}
                                                                    disabled
                                                                    color={changedList.includes('Client Id') ? 'var(--color-yellow)' : null}
                                                                    secondColor={changedList.includes('Client Id') ? 'var(--color-yellow)' : null}
                                                                    favoritesFieldName="Client"
                                                                    favoritesGroupName="Entities"
                                                                    favoritesVarKey={key.code}
                                                                    favoritesIdKey="Client Id"
                                                                />
                                                            </>
                                                            :
                                                            <>

                                                                <>
                                                                    <M_CheckBox
                                                                        icon={<LensOutlinedIcon />}
                                                                        checkedIcon={<CancelIcon />}
                                                                        checked={isChecked.includes(key.code)}
                                                                        onChange={(e) => addRejectFields(e, key.code, entitiesDict)}
                                                                    />
                                                                    <M_InputTextField
                                                                        label={key.label}
                                                                        value={entitiesDict.get(key.code) || ''}
                                                                        disabled
                                                                        color={changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                                                        secondColor={changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                                                        favoritesFieldName="Client"
                                                                        favoritesGroupName="Entities"
                                                                        favoritesVarKey={key.code}
                                                                        favoritesIdKey="Client Id"
                                                                    />
                                                                </>
                                                            </>
                                                    :
                                                    key.label === 'Client VAT' ?
                                                        <>
                                                            <M_CheckBox
                                                                icon={<LensOutlinedIcon />}
                                                                checkedIcon={<CancelIcon />}
                                                                checked={isChecked.includes(key.code)}
                                                                onChange={(e) => addRejectFields(e, key.code, entitiesDict)}
                                                            />
                                                            <M_InputTextField
                                                                label={key.label}
                                                                value={entitiesDict.get(key.code) || ''}
                                                                disabled
                                                                onChange={(e) => { }}
                                                                color={changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                                                secondColor={changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                                                favoritesFieldName="Client VAT"
                                                                favoritesGroupName="Entities"
                                                                favoritesVarKey={key.code}
                                                            />
                                                        </>
                                                        :
                                                        key.code === 'InvoiceCode' ?
                                                            <>
                                                                <M_CheckBox
                                                                    icon={<LensOutlinedIcon />}
                                                                    checkedIcon={<CancelIcon />}
                                                                    checked={isChecked.includes(key.code)}
                                                                    onChange={(e) => addRejectFields(e, key.code, entitiesDict)}
                                                                />
                                                                <M_DrawerTableTextField
                                                                    tableLabel={'Accounts'}
                                                                    label={key.label}
                                                                    value={extraValues.get('InvoiceId') ?
                                                                        {
                                                                            Id: extraValues.get('InvoiceId'),
                                                                            AccountCode: entitiesDict.get('InvoiceCode'),
                                                                            AccountVATNumber: entitiesDict.get('InvoiceVat'),
                                                                        } :
                                                                        null
                                                                    }
                                                                    entity={'Account'}
                                                                    filterField={"AccountCode"}
                                                                    labelFields={['AccountCode', 'AccountVATNumber']}
                                                                    onSubmitValue={(obj) => {
                                                                        if (obj) {
                                                                            addValue(`InvoiceId`, obj.Id, extraValues, setExtraValues)
                                                                            addValue('InvoiceCode', obj['AccountCode'], entitiesDict, setEntitiesDict)
                                                                            addValue('InvoiceVat', obj['AccountVATNumber'], entitiesDict, setEntitiesDict)
                                                                        } else {
                                                                            addValue(`InvoiceId`, '', extraValues, setExtraValues)
                                                                            addValue('InvoiceCode', '', entitiesDict, setEntitiesDict)
                                                                            addValue('InvoiceVat', '', entitiesDict, setEntitiesDict)
                                                                        }
                                                                    }}
                                                                    required={true}
                                                                    color={!entitiesDict.get(key.code) ? 'var(--color-red)' : changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                                                    secondColor={!entitiesDict.get(key.code) ? 'var(--color-red)' : changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                                                    favoritesFieldName="Invoice Entity"
                                                                    favoritesGroupName="Entities"
                                                                    favoritesIdKey="InvoiceId"
                                                                    favoritesVarKey="InvoiceCode"
                                                                />
                                                            </>
                                                            :
                                                            key.code === 'InvoiceVat' ?
                                                                <>
                                                                    <M_CheckBox
                                                                        icon={<LensOutlinedIcon />}
                                                                        checkedIcon={<CancelIcon />}
                                                                        checked={isChecked.includes(key.code)}
                                                                        onChange={(e) => addRejectFields(e, key.code, entitiesDict)}
                                                                    />
                                                                    <M_InputTextField
                                                                        label={key.label}
                                                                        value={entitiesDict.get(key.code) || ''}
                                                                        disabled
                                                                        onChange={(e) => { }}
                                                                        passRequired={true}
                                                                        secondColor={!entitiesDict.get(key.code) ? 'var(--color-red)' : changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                                                        color={!entitiesDict.get(key.code) ? 'var(--color-red)' : changedList.includes(key.id) ? 'var(--color-yellow)' : null}
                                                                        favoritesFieldName="Invoice VAT"
                                                                        favoritesGroupName="Entities"
                                                                        favoritesVarKey={key.code}
                                                                    />
                                                                </>
                                                                :
                                                                <>
                                                                    <M_CheckBox
                                                                        icon={<LensOutlinedIcon />}
                                                                        checkedIcon={<CancelIcon />}
                                                                        checked={isChecked.includes(key.code)}
                                                                        onChange={(e) => addRejectFields(e, key.code, entitiesDict)}
                                                                    />
                                                                    <M_InputTextField
                                                                        label={key.label}
                                                                        value={entitiesDict.get(key.code) || ''}
                                                                        onChange={(e) => addValue(key.code, e.target.value, entitiesDict, setEntitiesDict)}
                                                                        color={changedList.includes(key.code) ? 'var(--color-yellow)' : null}
                                                                        secondColor={changedList.includes(key.code) ? 'var(--color-yellow)' : null}
                                                                        favoritesFieldName={key.label}
                                                                        favoritesGroupName="Entities"
                                                                        favoritesVarKey={key.code}
                                                                    />
                                                                </>
                                                }
                                            </div>
                                        ))}
                                    </div>
                                }
                            />
                        </div>
                    </M_FormFavorites>
                    <M_FormFavorites
                        entityName="Bookings"
                        pageUrl="Booking"
                        varNameDict={locationsDict}
                        setVarNameDict={setLocationsDict}
                        onAfterApply={() => { }}
                    >
                        <div style={{ position: 'relative' }}>
                            <GroupFavoriteActions groupName="Ports" t={t} />
                            <M_Fieldset
                                labelInside
                                label={<span style={{ display: 'flex', alignItems: 'center', }}><Anchor style={{ marginRight: '5px' }} /> {t("Ports")}</span>}
                                elements={
                                    <div className='divTextfieldEntities'>
                                        {portsLocations.filter(obj => obj?.show).map((value, index) => (
                                            value.type === "textfield" ?
                                                <div key={index} className='textfield'>
                                                    <M_CheckBox
                                                        icon={<LensOutlinedIcon />}
                                                        checkedIcon={<CancelIcon />}
                                                        checked={isChecked.includes(value.label)}
                                                        onChange={(e) => addRejectFields(e, value.label, locationsDict)}
                                                    />
                                                    <M_DrawerTableTextField
                                                        tableLabel={'Locations'}
                                                        label={value.label}
                                                        value={extraValues.get(`${value.label} id`) ?
                                                            {
                                                                Id: extraValues.get(`${value.label} id`),
                                                                LocationName: locationsDict.get(value.label)
                                                            } :
                                                            null}
                                                        entity={'location'}
                                                        FILTER={'LocationPortStatus eq true'}
                                                        filterField={'LocationName'}
                                                        labelFields={['LocationName']}
                                                        onSubmitValue={(obj) => {
                                                            if (obj) {
                                                                addValue(`${value.label} id`, obj.Id, extraValues, setExtraValues)
                                                                addValue(value.label, obj['LocationName'], locationsDict, setLocationsDict)
                                                                addValue(value.label + ' ' + 'Code', obj['LocationCode'], locationsDict, setLocationsDict)
                                                            } else {
                                                                addValue(`${value.label} id`, '', extraValues, setExtraValues)
                                                                addValue(value.label, '', locationsDict, setLocationsDict)
                                                                addValue(value.label + ' ' + 'Code', '', locationsDict, setLocationsDict)
                                                            }
                                                        }}
                                                        required={value.code === 'LocationLoadingPortName' || value.code === 'LocationDischargePortName' ? true : false}
                                                        color={changedList.includes(value.id) ? 'var(--color-yellow)' : (value.code === 'LocationLoadingPortName' || value.code === 'LocationDischargePortName') && !locationsDict.get(value.label) ? 'var(--color-red)' : null}
                                                        secondColor={changedList.includes(value.id) ? 'var(--color-yellow)' : (value.code === 'LocationLoadingPortName' || value.code === 'LocationDischargePortName') && !locationsDict.get(value.label) ? 'var(--color-red)' : null}
                                                        favoritesFieldName={value.label}
                                                        favoritesGroupName="Ports"
                                                        favoritesIdKey={`${value.label} id`}
                                                        favoritesVarKey={value.label}
                                                    />
                                                </div>
                                                : value.type === "checkbox" ?
                                                    <div className='textfield paddingLeft' key={index}>
                                                        {value.label === "Transhipment" ?
                                                            <M_CheckBox
                                                                checked={locationsDict.get("Transhipment")}
                                                                label={value.label}
                                                                color={changedList.includes(value.code) ? 'var(--color-yellow)' : null}
                                                            />
                                                            :
                                                            <M_CheckBox />
                                                        }
                                                    </div>
                                                    :
                                                    ""
                                        ))}
                                    </div>
                                }
                            />
                        </div>
                    </M_FormFavorites>
                </div>
            </div>
            <M_Fieldset
                labelInside
                label={<span style={{ display: 'flex', alignItems: 'center', }}><i className="pi pi-box" style={{ marginRight: '10px' }}></i>  {t("Equipments")}</span>}
                elements={
                    <>
                        <M_CheckBox
                            label={t('rejectEquipments')}
                            icon={<LensOutlinedIcon />}
                            checkedIcon={<CancelIcon />}
                            checked={isChecked.includes('Equipments')}
                            onChange={(e) => addRejectFields(e, 'Equipments', equipmentDict)}
                        />
                        {useMemo(() => <TableEquipments
                            id={id}
                            value={shipmentObjArray}
                            setValue={setShipmentObjArray}
                            isApprove={true}
                            selectedLine={selectedLine}
                            setSelectedLine={setSelectedLine}
                            openDrawer={openDrawer}
                            setOpenDrawer={setOpenDrawer}
                            reprovedRows={reprovedRows}
                            setReprovedRows={setReprovedRows}
                            onReprove={onReprove}
                            extraValuesArray={extraValues}
                            toastMessages={toastMessages}
                            drawerName={drawerName}
                            setDrawerName={setDrawerName}
                            bookingLine={bookingLine}
                            draft={draft}
                            shipmentArray={shipmentArray}
                            setShipmentArray={setShipmentArray}
                            fieldsInDrawerShipment={fieldsInDrawerShipment}
                            fieldsInDrawerEquipment={fieldsInDrawerEquipment}
                        />, [shipmentObjArray,
                            setShipmentObjArray,
                            shipmentArray,
                            setShipmentArray,
                            openDrawer,
                            setOpenDrawer,
                            selectedLine,
                            setSelectedLine,
                            extraValues,
                            toastMessages,
                            drawerName,
                            setDrawerName,
                            bookingLine,
                            draft,
                            id,
                            fieldsInDrawerEquipment,
                            fieldsInDrawerShipment,])}
                    </>
                }
            />
            {isAdmin && (
                <div className='divForm'>
                    <M_Fieldset
                        labelInside
                        label={<span style={{ display: 'flex', alignItems: 'center' }}><RequestQuoteOutlined style={{ marginRight: '10px' }} /> {t('ShipmentCharges')}</span>}
                        elements={
                            <TableShipmentCharges
                                value={shipmentChargesArray}
                                shipments={availableShipments}
                                onOpenCreate={availableShipments.length > 0 ? handleOpenCreate : undefined}
                                onOpenEdit={handleOpenEdit}
                                onRefresh={onRefreshCharges}
                            />}
                    />
                </div>
            )}

            <M_MessageBoard
                open={openConfirmModal}
                onClose={handleCloseConfirmModal}
                title={t("LabelRejectBooking")}
                body={
                    <>
                        <span style={{}}>
                            {/* <span className='reasonSpan' style={{ marginRight: '10px' }}>{t("Reason")}: </span> */}
                            <M_RadioButton
                                label={t("Reason")}
                                options={[
                                    { label: t("LabelOther"), value: "Other", },
                                    { label: t("LabelFullVessel"), value: "Full vessel", },
                                    { label: t("LabelWrongFields"), value: "Wrong fields", },
                                ]}
                                selectedValue={radioButton}
                                onChange={(e) => { setRadioButton(e.target.value) }}
                            />
                            {radioButton === "Wrong fields" && <span>
                                {rejectFields?.map((obj, index) => (
                                    obj?.key === 'Equipments' ?
                                        <span key={index}>
                                            <M_TextArea label={`${obj.key} ${obj?.value ? ':' + obj?.value : ''}`} onChange={(e) => rejectFieldsNotes(obj, e.target.value)} />
                                        </span>
                                        :
                                        <span key={index}>
                                            <M_InputTextField label={`${obj.key} ${obj?.value ? ':' + obj?.value : ''}`} onChange={(e) => rejectFieldsNotes(obj, e.target.value)} />
                                        </span>
                                ))}
                                {reprovedRows?.map((obj, index) => (
                                    <span key={index}>
                                        <M_InputTextField value={obj.Notes || ''} label={`Line id ${obj.id} - Type: ${obj['Equipment Type']} - Description: ${obj['Cargo Description']} - Weight: ${obj['Load Weight (KG)']}`} onChange={(e) => onReprove(obj, e.target.value)} />
                                    </span>
                                ))}
                            </span>}

                        </span>
                        <M_TextArea
                            label={t("Notes")}
                            value={finalNotes}
                            onChange={(e) => setFinalNotes(e.target.value)}
                        />
                    </>
                }

                footer={
                    <M_Button
                        hoverEffect
                        normal
                        labelColor={'white'}
                        backgroundColor={'var(--color-green)'}
                        onClick={submitedReproval}
                        label={t("ConfiRejecBook")}
                    />
                }
            />
            <M_MessageBoard
                onClose={approveSuccess ? confirmApproval : closeModal}
                open={confirmationModal}
                title={isApprove ? approveSuccess ? t("submitBookingApproval") : t("submitBookingNotApproval") : approveSuccess ? t("submitBookingRejected") : t("submitBookingNotRejected")}
                body={isApprove ?
                    approveSuccess ?
                        <b>
                            <span className='modalgrid'>
                                <DoneOutlinedIcon /> <span className='spanItems'>  {t("Booking_Approval_Sent")}</span>
                            </span>
                        </b>
                        :
                        <b>
                            <span className='modalgrid'>
                                <ErrorOutlineIcon />
                                <span className='spanItems'>
                                    {Array.isArray(errorMessage) ?
                                        errorMessage.map((error, ind) => (
                                            <span key={ind}>{error}</span>
                                        ))
                                        :
                                        <span >{errorMessage}</span>
                                    }
                                </span>
                            </span>
                        </b>
                    :
                    approveSuccess ?
                        <b>
                            <span className='modalgrid'>
                                <DoneOutlinedIcon /> <span className='spanItems'>  {t("Rejected")}</span>
                            </span>
                        </b>
                        :
                        <b>
                            <span className='modalgrid'>
                                <ErrorOutlineIcon /> <span className='spanItems'>  {t("notRejected")}</span>
                            </span>
                        </b>}
                footer={approveSuccess ?
                    <span style={{ display: 'flex' }}>
                        <M_Button hoverEffect normal backgroundColor={'var(--color-green)'} labelColor={'var(--color-white)'} label={t("ButtonConfirm")} onClick={confirmApproval} />
                        <M_Button hoverEffect normal backgroundColor={'var(--color-red)'} labelColor={'var(--color-white)'} label={t("ButtonCancel")} onClick={closeModal} />
                    </span>
                    : ''
                }
            />
            <M_MessageBoard
                warning
                open={leavingPage}
                onClose={functionLeavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBody")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={functionLeavingPage} label={t("ButtonConfirm")} />
                    </span>
                }
            />
        </div >
    )
}
